import { computed, type Ref } from 'vue';
import {
  isStopFieldEditable,
  type ShipmentEditCapabilities,
} from '@/components/shipment/edit/utils/shipment-edit-capabilities';

export function useShipmentFormStopLocks(
  capabilities: Ref<ShipmentEditCapabilities>,
) {
  function getStopDisabledFields(index: number, total: number) {
    const caps = capabilities.value;
    const role =
      index === 0 ? 'origin' : index === total - 1 ? 'destination' : null;
    if (role == null) {
      if (!caps.canEditRoute) {
        return {
          location: true,
          radius: true,
          plannedDeparture: true,
          plannedArrival: true,
        };
      }
      return {};
    }
    const group = role === 'origin' ? caps.origin : caps.destination;
    if (!group.editable) {
      return {
        location: true,
        radius: true,
        plannedDeparture: true,
        plannedArrival: true,
      };
    }
    return {
      location: !isStopFieldEditable(caps, role, 'location'),
      radius: !isStopFieldEditable(caps, role, 'radius'),
      plannedDeparture: !isStopFieldEditable(caps, role, 'plannedDeparture'),
      plannedArrival: !isStopFieldEditable(caps, role, 'plannedArrival'),
    };
  }

  function getStopLockReason(index: number, total: number) {
    const role =
      index === 0 ? 'origin' : index === total - 1 ? 'destination' : null;
    if (role == null) return undefined;
    const group =
      role === 'origin' ? capabilities.value.origin : capabilities.value.destination;
    return group.editable ? undefined : group.lockReason;
  }

  const hideWaypointControls = computed(
    () => !capabilities.value.canEditRoute,
  );

  function getStopLockBadgeLabel(index: number, total: number) {
    const role =
      index === 0 ? 'origin' : index === total - 1 ? 'destination' : null;
    if (role == null) return undefined;
    const group =
      role === 'origin' ? capabilities.value.origin : capabilities.value.destination;
    return group.editable ? undefined : group.lockBadgeLabel;
  }

  return {
    getStopDisabledFields,
    getStopLockReason,
    getStopLockBadgeLabel,
    hideWaypointControls,
  };
}
